<div class="flex-row column bg-color-F6FAFB border-radius-8 p-30 row-gap-35">
  <button type="button" class="flex-row align-center cursor-pointer bg-color-F6FAFB content-center d-none-md"
    (click)="closeDialog()" aria-label="Close">
    <x-icon [width]="'20px'" [height]="'20px'" [iconColor]="'#4334ec'"
      class="p-5 border-color-4334ec border-radius-circle"></x-icon>
  </button>
  <div class="flex-row content-between column-md row-gap-md-25 column-ms-gap-30 column-gap-40">
    <div class="flex-row column row-gap-18">
      <div class="content-between d-none d-flex-md">
        <h2 class="fs-16 fw-6">Regulatory Disclosure</h2>
        <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0" (click)="closeDialog()" aria-label="Close">
          <x-icon [width]="'20px'" [height]="'20px'" [iconColor]="'#4334ec'" class="cursor-pointer"
            aria-hidden="true"></x-icon>
        </button>
      </div>
      <h2 class="fs-24 fw-6 d-none-md">Regulatory Disclosure</h2>
      <p class="text-dark fs-16 fs-md-12 fw-md-3 lh-md-20 lh-25" style="max-width:413px;">{{advisorData.name}} is a SEBI
        {{advisorData.advisorType ==='ra_registered'? 'registered Research Analyst': 'Registered Investment Advisor'}}
        (Registration Number: {{advisorData.sebiRegNo}}) SEBI requires {{advisorData.advisorType ==='ra_registered'?
        'RA’s': 'RIA’s'}} to disclose complaint status on their homepage. Pursuant to the same, please note:</p>
    </div>
    <div class="flex-row column content-between row-gap-20">
      <div class="flex-row text-dark fw-3 fs-md-12 column-md-gap-50">
        <p class="min-width-28 width-md-16 min-width-md-16 flex-row column row-gap-5">COMPLAINT STATUS<span>AS ON
            {{advisorComplaint?.updatedAt | date:"dd-MMM-yyyy" }}</span></p>
        <p class="flex-row column row-gap-5">NO OF<span>COMPLAINTS</span></p>
      </div>
      <div class="flex-row text-dark fw-6 fs-md-12 column-md-gap-50">
        <p class="min-width-28 width-md-16 min-width-md-16">At the beginning of the month</p>
        <p>{{advisorComplaint?.beginingMonth || "0"}}</p>
      </div>
      <div class="flex-row text-dark fw-6 fs-md-12 column-md-gap-50">
        <p class="min-width-28 width-md-16 min-width-md-16">Received during the month</p>
        <p>{{advisorComplaint?.receivedDuringMonth || "0"}}</p>
      </div>
      <div class="flex-row text-dark fw-6 fs-md-12 column-md-gap-50">
        <p class="min-width-28 width-md-16 min-width-md-16">Resolved during the month</p>
        <p>{{advisorComplaint?.resolvedDuringMonth || "0"}}</p>
      </div>
      <div class="flex-row text-dark fw-6 fs-md-12 column-md-gap-50">
        <p class="min-width-28 width-md-16 min-width-md-16">Pending at the end of the month</p>
        <p>{{advisorComplaint?.pendingEndOfMonth || "0"}}</p>
      </div>
      <div class="flex-row text-dark fw-6 fs-md-12 column-md-gap-50">
        <p class="min-width-28 width-md-16 min-width-md-16">Reason for pendency</p>
        <p>{{advisorComplaint?.reasonForDendency || "No complaints"}}</p>
      </div>
    </div>
  </div>
</div>